import { render, staticRenderFns } from "./BaixarArquivo.vue?vue&type=template&id=6d59b050"
import script from "./BaixarArquivo.vue?vue&type=script&lang=js"
export * from "./BaixarArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports